module.exports = __webpack_public_path__ + "img/1500781219.acae6971.jpg";